<opac-swiper [configuration]="swiperConfig">
  <opac-swiper-item *ngFor="let monthlyItem of swiperMonthlyItems">
    <opac-record-cover
      (click)="navToInfo(monthlyItem)"
      [coverUrl]="monthlyItem.coverUrl"
      [showIcon]="false"
      [attr.aria-label]="('general.coverAlt' | translate) + ' ' + monthlyItem?.title"
    ></opac-record-cover>
  </opac-swiper-item>
</opac-swiper>
